import axios from "axios";
import { API } from "@/context/AuthContext";

const BASE = `${API}/product-catalog`;

export const productCatalogApi = {
  list: async () => (await axios.get(`${BASE}/products`)).data,
  get: async (id) => (await axios.get(`${BASE}/products/${id}`)).data,
  create: async (payload) => (await axios.post(`${BASE}/products`, payload)).data,
  update: async (id, payload) => (await axios.put(`${BASE}/products/${id}`, payload)).data,
  remove: async (id) => (await axios.delete(`${BASE}/products/${id}`)).data,
  replaceTypes: async (id, types) =>
    (await axios.put(`${BASE}/products/${id}/types`, types)).data,
  replaceQuantities: async (id, quantities) =>
    (await axios.put(`${BASE}/products/${id}/quantities`, quantities)).data,
  replaceExtras: async (id, extras) =>
    (await axios.put(`${BASE}/products/${id}/extras`, extras)).data,
  getMatrix: async (id) => (await axios.get(`${BASE}/products/${id}/matrix`)).data,
  saveMatrix: async (id, cells) =>
    (await axios.put(`${BASE}/products/${id}/matrix`, { cells })).data,
};
